import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const handleLogin = () => {
    setMenuOpen(false);
    navigate('/login');
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    navigate('/');
    // Scroll to top smoothly
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo">
          <a href="/" onClick={handleLogoClick}>
            <img src="https://proctur.com/assets/img/logo.svg" alt="Proctur" />
          </a>
        </div>

        <nav className={`header-nav ${menuOpen ? 'active' : ''}`}>
          <a href="#templates" onClick={() => setMenuOpen(false)}>Templates</a>
          <a href="#features" onClick={() => setMenuOpen(false)}>Features</a>
          <a href="#categories" onClick={() => setMenuOpen(false)}>Categories</a>
          <a href="https://proctur.com/website/contact-us" target="_blank" rel="noopener noreferrer">Support</a>
        </nav>

        <div className="header-actions">
          {isAuthenticated ? (
            <>
              <span className="admin-badge">
                <i className="fa fa-user-shield"></i>
                Admin
              </span>
              <button onClick={handleLogout} className="btn-header-logout">
                <i className="fa fa-sign-out-alt"></i>
                Logout
              </button>
            </>
          ) : (
            <button onClick={handleLogin} className="btn-header-login">
              <i className="fa fa-sign-in-alt"></i>
              Admin Login
            </button>
          )}
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          <i className={`fa ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>
    </header>
  );
};

export default Header;
